import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyCCJRIbFN8KBMFq3BsTWVoidywoJinid6w",
    authDomain: "invoicelypro.magnaopussoftware.in",
    projectId: "invoicelypro",
    storageBucket: "invoicelypro.firebasestorage.app",
    messagingSenderId: "305115119147",
    appId: "1:305115119147:web:85f3ed6631571a5e28f46e",
    measurementId: "G-3L2F250YPC"
  };
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);